import { isDefined } from 'common';
import { type LlmModelName } from 'llm-model-registry';

import { ClinicalQuestionAssistantDefaultValueAdornment } from './DefaultValueAdornment';
import { CLINICAL_QUESTION_ASSISTANT_DEFAULT_MODEL } from './defaults';
import { BlockSelectField } from '../../../../ConfigFields/SelectField';
import { useSelectedNodeField } from '../../../../ConfigFields/useSelectedNodeField';
import { llmModelOptions } from '../../../Llm/Shared/SharedFormFields';

interface ClinicalQuestionAssistantDefaultModelFieldProps {
  fieldName: string;
}

export function ClinicalQuestionAssistantDefaultModelField(
  props: ClinicalQuestionAssistantDefaultModelFieldProps
) {
  const { fieldName } = props;
  const { setValue, value } = useSelectedNodeField<LlmModelName | undefined>(fieldName);

  return (
    <BlockSelectField
      label="Model"
      fieldName={fieldName}
      options={llmModelOptions}
      defaultValue={CLINICAL_QUESTION_ASSISTANT_DEFAULT_MODEL}
      helperText="Choose which LLM model to use. Leave unchanged to follow the assistant's runtime default."
      labelAdornment={
        <ClinicalQuestionAssistantDefaultValueAdornment
          displayedValue={value ?? CLINICAL_QUESTION_ASSISTANT_DEFAULT_MODEL}
          valueState={isDefined(value) ? 'Customized' : 'UsingDefault'}
          resetValue={() => {
            setValue(undefined);
          }}
        />
      }
    />
  );
}
